export const roles = {
  title: 'Roles',
  subtitle:
    'Manage user roles and define which system resources they can access',
  searchPlaceholder: 'Search for a role...',
  allRoles: 'All roles',
  rolesCount: '{count} roles',
  add: 'Add role',
  deleteRole: 'Delete role',
  deletedQuestion: 'Are you sure you want to delete the role: {roleName}?',
  deleteSuccess: 'Role deleted',
  createdRole: 'Role created',
  savedChanges: 'Changes saved',
  saveChanges: 'Save changes',
  selectRole: 'Select a role to see its details',
  details: 'Role details',
  roleId: 'Role ID',
  nameLabel: 'Role name',
  descriptionLabel: 'Role description',
  descriptionPlaceholder: 'Add a role description (optional)',
  baseRoleNotice:
    'This role was created by the system. Its name cannot be edited and it cannot be deleted. Only permissions can be edited.',
  permissionsTitle: 'Permissions',
  permissionsSubtitle: 'Define what users with this role can view and change',
  noRolesFound: 'No roles found',
  titles: {
    flowEngine: 'Flow permissions',
    users: 'Client permissions',
    roles: 'Administrator permissions',
  },
  create: {
    title: 'New role',
    description: 'Create a new role and give it basic information.',
    submit: 'Create role',
    namePlaceholder: 'e.g. moderator',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Short role description (optional)',
    permissionsNotice:
      'You will set permissions in the next step, right after creating the role.',
  },
}
